import React from 'react';

import { ReviewTransactions } from '../components/Approvals/ReviewTransactions.component';

export const ApprovalsPage: React.FC = () => {
  return <ReviewTransactions />;
};
